import {useOutletContext, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import { Client } from '../Api/Client';
import GraphSection from "../ContentSections/GraphSection";
import LinksSection from "../ContentSections/LinksSection";
import ContentSection from "../ContentSections/ContentSection";
import TableSection from "../ContentSections/TableSection";
import Spinner from "../Components/Spinner";
import LineChartSection from "../ContentSections/LineChartSection";
import MapSection from "../ContentSections/MapSection";
import Page from "../Components/Page";

function JobDetailPage() {
    const params = useParams();
    const endpoint = `/pages/jobs/${params.type}`;

    return <Page endpoint={endpoint} />
}

export default JobDetailPage;